// Pure presentation helpers for avatars. Kept separate from avatar.ts (which
// imports Firebase Storage for uploads) so components that only need the initials
// fallback don't pull the storage dependency into their module graph.

// Initials shown as a neutral fallback when a user/company has no uploaded avatar.
// Returns up to two uppercase letters from the given name (e.g. "Some Company" -> "SC").
export function getInitials(name: string | undefined | null): string {
  if (!name) return "";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

// Consistent styling for the initials-fallback avatar across the app: a neutral
// background with high-contrast text, and a font scaled to ~40% of the avatar so
// the letters always have breathing room (MUI's default font is fixed regardless
// of size, which makes small avatars look cramped). `size` is the avatar diameter
// in px. Spread this AFTER any width/height in the Avatar's sx.
export const initialsAvatarSx = (size: number) => ({
  bgcolor: "grey.300",
  color: "text.primary",
  fontWeight: 600,
  fontSize: `${Math.round(size * 0.4)}px`,
});
